// ~/stores/authStore.js
import { defineStore } from "pinia";
//import { useCartStore } from "./cartStore";
import { navigateTo } from "#app";
export const useAuthStore = defineStore("auth", {
  state: () => ({
    isRestored: false,
    isLoggedIn: false,
    profile: {
      user_id: null,
      firstName: "",
      lastName: "",
      username: "",
      email: "",
      picture: null,
      roles: [],
     // progress: [],
    },
  }),

  getters: {
    fullName: (state) =>
      `${state.profile.firstName} ${state.profile.lastName}`.trim(),
    hasRole: (state) => (role) => state.profile.roles.includes(role),
    hasAnyRole: (state) => (roles) =>
      roles.some((r) => state.profile.roles.includes(r)),
  },

  actions: {
    // Charge le profil et la progression depuis /api/auth/me
    async fetchProfileFromServer() {
      try {
        // 1️⃣ Appel à l’API
        const res = await $fetch("/api/auth/me", {
          credentials: "include",
        });

        // 2️⃣ Si l’API renvoie un échec ou pas de success
        if (!res || !res.success) {
          this.resetProfile();
          return false;
        }

        // 3️⃣ Sinon on hydrate le store
        const { profile, content } = res;
        this.setProfile(profile || []);
        this.isLoggedIn = true;
        return true;
      } catch (err) {
        console.error("fetchProfileFromServer error:", err);
        this.resetProfile();
        return false;
      }
    },

    // Initialisation à l’app démarrage
    async restoreAuth() {
      if (this.isRestored) return this.isLoggedIn;
      const ok = await this.fetchProfileFromServer();

      this.isRestored = true;
      return ok;
    },

    // Connexion
    async login({ email, password }) {
      try {
        const response = await fetch("/api/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
          credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || "Erreur connexion");
        if (data.success) {
          await this.fetchProfileFromServer();
          return true;
        }
      } catch (err) {
        console.error("login error:", err);
        throw err;
      }
    },

    // Déconnexion
    async logout() {
      try {
        await fetch("/api/logout", { method: "POST", credentials: "include" });
      } catch {
        // non bloquant
      }

      //////
      // Nettoyage local du panier (import dynamique pour éviter la boucle)
      const { useCartStore } = await import("~/stores/cartStore");
      const cart = useCartStore();
      cart.items = [];
      // Supprimer le panier invité si existant (client-only)
    if (process.client && typeof localStorage !== "undefined") {
      localStorage.removeItem("guestCart");
    }
      this.resetProfile();
      await navigateTo("/login");
      this.isLoggedIn = false;
    },

    // Met à jour le profil et la progression
    setProfile(profile) {
      this.profile = {
        user_id: profile.user_id,
        firstName: profile.firstName || "",
        lastName: profile.lastName || "",
        username: profile.username || "",
        email: profile.email || "",
        picture: profile.picture || null,
        roles: Array.isArray(profile.roles) ? profile.roles : [],
        //  progress: Array.isArray(progress) ? progress : [],
      };
    },

    // Reset complet
    resetProfile() {
      this.profile = {
        user_id: null,
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        picture: null,
        roles: [],
        // progress: [],
      };
      this.isLoggedIn = false;
    },
  },
});
